import { Injectable } from '@angular/core';

import { IMetaTable, IMetaTableColumn } from '../types';

import { Api } from './api';

@Injectable({
    providedIn: 'root'
})
export class DataDictionaryApi {
    constructor(private readonly api: Api) { }

    async getColumnsWithDomainValuesByMetaTableId(tableId: number) {
        let retVals: IMetaTableColumn[] = [];
        const results = await this.api.http2.graphqlRequest<IMetaTable[]>(`
            query GetMetaTable($tableId: [Int]) {
                metaTables(id: $tableId) {
                    columns {
                        columnName
                        columnAlias
                        domainValues {
                            codeValue
                            longDescription
                            shortDescription
                        }
                    }
                }
            }
        `, { tableId }, 'GET', 'metaTables');
        if (results && results.length) {
            retVals = results[0].columns;
        }
        return retVals;
    }

    async getColumnsWithDomainValuesByTableName(tableName: string) {
        let retVals: IMetaTableColumn[] = [];
        const results = await this.api.http2.graphqlRequest<IMetaTable[]>(`
            query GetMetaTable($tableName: [String]) {
                metaTables(name: $tableName) {
                    columns {
                        columnName
                        columnAlias
                        domainValues {
                            codeValue
                            longDescription
                            shortDescription
                        }
                    }
                }
            }
        `, { tableName }, 'GET', 'metaTables');
        if (results && results.length) {
            retVals = results[0].columns;
        }
        return retVals;
    }
}
